import React from 'react';
import { Link } from 'react-router-dom';

const FooterLinks = ({ title, links }) => {
  return (
    <div className="mb-8 md:w-[254px]">
      <p className="font-inter text-md xs:text-xl mb-4 font-bold">{title}</p>
      <ul>
        {links.map((link, index) => (
          <li key={index} className="mb-2">
            <Link
              to={link.url}
              className="xs:text-base text-xs hover:underline"
            >
              {link.text}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterLinks;
